<p class="font-bold text-truncate col p-0 mb-2 auto-complete-label" id="{{uniqueId}}{{index}}"
  *ngIf="isLableShow===true" (click)="openPanel(toggle=false)">
  {{autoCompleteTitle}} <span class="mandatory" *ngIf="isMandatory">*</span>
</p>

<div class="position-relative auto-complete">
  <div class="row position-relative auto-complete__selection">
    <div [ngClass]="(selectType === 'multi') ? 'col-11' : 'col-12'">
      <div class="position-relative">
        <div class="col p-0" [ngClass]="toggle? (treeView?
          'auto-complete__opened position-relative' : (viewLocation === 'navbar'? 
          'auto-complete__opened position-absolute': 'auto-complete__opened position-relative')):''"
          [attr.class]="viewLocation === 'navbar'?'adj-position':''">

          <ng-container *ngIf="showSelectionInput">
            <button type="button" id="{{autoCompleteTitle?.split(' ').join('')}}" role="combobox"
              [attr.aria-expanded]="toggle" aria-owns="dropdownList_{{uniqueId}}{{index}}" aria-haspopup="listbox"
              attr.aria-labelledby="{{uniqueId}}{{index}} select"
              class="btn btn-clear border text-left custom-select font-bold class-1 form-control" [ngClass]="{'opened':toggle===true, 'cursor-pointer': !disabled, 'cursor-not-allowed': disabled,
              'ng-touched ng-dirty ng-invalid': (isMandatory && showErr && showValidMsg)}" [disabled]="disabled"
              (click)="openPanel(toggle = (toggle === false ? true :false))"
              (keyup.enter)="openPanel(toggle = (toggle === false ? true :false))"
              *ngIf="selectedArrayObj.length === 0">
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 132.813 132.031" class="animated-loader" *ngIf="showSpinner" aria-hidden="true">
                <path id="loader" d="M140.625,128.906a47.379,47.379,0,0,0,8.594-20.7h16.8a67.265,67.265,0,0,1-13.281,32.422ZM108.2,149.219a47.379,47.379,0,0,0,20.7-8.594l12.109,12.109A65.626,65.626,0,0,1,108.2,166.016ZM166.016,91.8h-16.8a47.379,47.379,0,0,0-8.594-20.7l12.109-11.719A60.853,60.853,0,0,1,166.016,91.8ZM91.8,50.781A49.458,49.458,0,0,0,61.914,67.773,47.949,47.949,0,0,0,50,100a47.949,47.949,0,0,0,11.914,32.227A49.458,49.458,0,0,0,91.8,149.219v16.8q-24.609-3.125-41.6-21.875A63.594,63.594,0,0,1,33.2,100,63.594,63.594,0,0,1,50.2,55.859q16.992-18.75,41.6-21.875Z" transform="translate(-33.203 -33.984)"/>
              </svg>
              <span id="select">{{showSpinner ? 'Loading data' : 'Select'}}</span>
            </button>
            <div role="combobox" [attr.aria-expanded]="toggle" aria-owns="dropdownList_{{uniqueId}}{{index}}"
              aria-haspopup="listbox" tabindex="0" attr.aria-labelledby="{{uniqueId}}{{index}}"
              (keyup.enter)="openPanel(toggle = (toggle === false && !disabled ? true :false))"
              class="text-left custom-select font-bold class-2 auto-complete__choice-holder form-control" [ngClass]="{'opened':toggle===true, 'cursor-pointer': !disabled, 'cursor-not-allowed': disabled,
              'ng-touched ng-dirty ng-invalid': (isMandatory && showErr && showValidMsg)}" id="{{'dropdBtn-'+index}}"
              [disabled]="disabled" *ngIf="selectedArrayObj.length > 0"
              (click)="openPanel(toggle = (toggle === false && !disabled ? true :false))">
              <div class="d-inline-flex col-auto text-truncate auto-complete__choice-tag mx-1"
                [ngClass]="{'w-single px-0':selectType==='single', 'w-multi px-2':selectType==='multi'}"
                *ngFor="let option of selectedArrayObj">
                <div class="d-flex justify-content-center align-items-center"
                  [ngClass]="{'col p-0':selectType==='single'}">
                  <span id="{{option[propName]}}"
                    [ngClass]="{'w-100':selectType==='single', 'w-lock':selectType==='multi'}"
                    class="text-truncate tag">{{option[propName]}}</span>
                  <button *ngIf="canDelete" (click)="((disabled===true) ? false : deleteObj(option,$event))"
                    id="deleteSelectedElement" class="auto-complete__choice-tag__remove btn-icon col-auto p-1"
                    [ngClass]="{'cursor-pointer': !disabled, 'cursor-not-allowed': disabled}"
                    attr.aria-label="Remove item {{option[propName]}}">
                    <span class="material-icons-outlined ic-clear" aria-hidden="true">
                      close
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div class="error--txt" *ngIf="isMandatory && showErr && showValidMsg" role="alert">
              <p class="font-bold m-0 d-flex align-items-center mt-1">
                <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                {{autoCompleteTitle}} is required
             </p>
            </div>

          </ng-container>
          <div [ngClass]="{'show':toggle, 'tenant-dropdown':!showSelectionInput}">
            <span *ngIf="!showSelectionInput" class="tooltip top font-1x position-relative"
              [attr.aria-label]="'Tenants'" data-tooltip="Tenants">
              <button class="btn btn-clear p-0" type="button" id="tenantsdropdown" aria-haspopup="true"
                [attr.aria-expanded]="toggle" (click)="openPanel(toggle = (toggle === false ? true :false))"
                aria-label="show tenant list">
              </button>
            </span>
            <div class="auto-complete__list position-absolute" #dropdown id="auto-complete__list_{{uniqueId}}{{index}}"
              [ngStyle]="{'display':(toggle && !disabled) ? 'block !important' : 'none' }"
              [ngClass]="{'border-top tenant-search':!showSelectionInput, 'dropdown-menu-right':treeView , 'd-block' : toggle}">
              <div class="auto-complete__search position-relative">
                <span class="material-icons-outlined" aria-hidden="true">search</span>
                <label for="metadataSetDropdown{{uniqueId}}{{index}}" id="searchLabel" class="sr-only">search</label>
                <input id="metadataSetDropdown{{uniqueId}}{{index}}" type="search" class="form-control font-bold"
                  placeholder="Search" (keyup)="searchMetadata()" [(ngModel)]="search" autocomplete="off"
                  aria-autocomplete="both"
                  [attr.aria-label]="searchListReult && searchListReult.length && search && search.length>0? (searchListReult && searchListReult.length === 1 &&  !(searchListReult[0]?.uniqueId) ?'No Record found': searchListReult.length +' results are available'): ''"
                  attr.aria-owns="dropdownList_{{uniqueId}}{{index}}" aria-describedby="initInstr" aria-expanded="false"
                  aria-activedescendant="selectedData">
              </div>

              <ul id="dropdownList_{{uniqueId}}{{index}}" class="list-unstyled auto-complete__list__items mb-0 px-0"
                role="listbox" attr.aria-labelledby="metadataSetDropdown{{uniqueId}}{{index}}">
                <li id="{{currentItem===i?'selectedData':null}}" *ngFor="let data of searchListReult; let i =index;"
                  role="option" [attr.aria-selected]="currentItem===i?true:false" tabxindex="{{currentItem===i?0:-1}}"
                  (focus)="onFocus(i)">
                  <p class="mb-0 py-3 font-bold px-3 set-divider" *ngIf="data?.displayOnly">{{data[propName]}}</p>
                  <button *ngIf="!data?.displayOnly && data?.uniqueId !== null"
                    id="{{data[propName]?.split(' ').join('') + '_'+i}}" type="button"
                    [class.no-record]="data?.uniqueId===null"
                    [ngClass]="(disableOption && data.is_selected===1?'selected':'')" (click)="selectObject(data);"
                    class="btn-clear w-100 border-0 text-left pl-0 py-2 options"
                    [disabled]="disableOption && data.is_selected===1">
                    <span class="d-flex w-100">
                      <span class="col">{{data[propName]}}</span>
                      <span class="col" *ngIf="data.is_custom===0">
                        <span class="text-uppercase case">Case</span>
                      </span>
                    </span>
                  </button>
                  <p tabindex="0" *ngIf="!data?.displayOnly && data?.uniqueId === null"
                    id="{{data[propName]?.split(' ').join('') + '_'+i}}" [class.no-record]="data?.uniqueId===null"
                    role="alert">
                    <span class="d-flex w-100">
                      <span class="col"><span class="sr-only">Error</span> {{data[propName]}}</span>
                    </span>
                  </p>
                </li>
              </ul>

              <span id="initInstr" style="display: none;">When autocomplete results are available use tab key
                to focus and review. Press enter to select.</span>
              <div aria-live="assertive" class="screen-reader-text"></div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="col-1 pl-0" *ngIf="selectType === 'multi'">
      <button class="btn btn-primary top d-inline-block lg btn-workflow d-flex h-100" id="{{autoCompleteTitle?.split(' ').join('') + '_addMulti_'+ index}}" (click)="addObj();"
        [ngClass]="{'tooltip': selectedArrayObj.length>0 && !disabled}" aria-label="Add to continue"
        [disabled]="selectedArrayObj.length<1 || disabled">
          <span class="material-icons-outlined font-4x" aria-hidden="true">add</span>
        </button>
    </div>
  </div>
</div>
